import getTableComponent from '../../getTableComponent';
import schemas from 'src/products/admin/redux/tables/schemas';

const DatatablesList = getTableComponent(schemas.datatables);
export default DatatablesList;
